import React, { useEffect, useRef, useState } from "react";
import { useSearchParams } from "react-router-dom";
import styled from "@emotion/styled";
import { ThemeProvider, neoTheme, CompassColor } from "@noom/wax-component-library";

import { sendBuyflowExit, isInsideWebView } from "../utils/nativeNavigation";
import { useAuthCredentials } from "../hooks/useAuthCredentials";

const PageWrapper = styled.div`
  background-color: ${CompassColor.white};
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: "Untitled Sans", sans-serif;
`;

const StatusText = styled.p`
  font-size: 16px;
  color: #6b7280;
  text-align: center;
`;

type Props = {
  apiCall: (accessCode: string, accessToken: string, orderId: string) => Promise<unknown>;
  successToast: string;
  loadingText: string;
};

export const ConfirmOrderActionPage = ({ apiCall, successToast, loadingText }: Props) => {
  const [searchParams] = useSearchParams();
  const orderId = searchParams.get("orderId");
  const { accessCode, accessToken } = useAuthCredentials();
  const [error, setError] = useState<string | null>(
    orderId ? null : "Missing order ID"
  );
  const calledRef = useRef(false);

  useEffect(() => {
    if (calledRef.current || error) return;
    if (!accessCode || !orderId) return;
    calledRef.current = true;

    const run = async () => {
      try {
        await apiCall(accessCode, accessToken ?? "", orderId);
        if (isInsideWebView()) {
          sendBuyflowExit({ toast: successToast });
        } else {
          window.alert(successToast);
        }
      } catch {
        const errorToast = "Something went wrong, try again";
        if (isInsideWebView()) {
          sendBuyflowExit({ toast: errorToast });
        } else {
          setError(errorToast);
        }
      }
    };

    run();
  }, [accessCode, accessToken, orderId, error, apiCall, successToast]);

  if (error) {
    return (
      <ThemeProvider theme={neoTheme}>
        <PageWrapper>
          <StatusText>{error}</StatusText>
        </PageWrapper>
      </ThemeProvider>
    );
  }

  return (
    <ThemeProvider theme={neoTheme}>
      <PageWrapper>
        <StatusText>{loadingText}</StatusText>
      </PageWrapper>
    </ThemeProvider>
  );
};
